export default "__VITE_ASSET__B44_rVcg__"